import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useDidMountEffect, useQueryList, useRequiredParams } from '@percent/admin-dashboard/common/hooks'
import { DisbursementDonationsTable } from './disbursementDonationsTable/DisbursementDonationsTable'

export function DisbursementDonationsContainer() {
  const { batchId, disbursementId } = useRequiredParams()
  const { disbursementsService } = useServices()

  const [{ totalResults, isLoading, dataOrNull, errorMessageOrNull }, { nextPage, query, previousPage }] = useQueryList(
    disbursementsService.getDisbursementDonations,
    {
      disbursementId
    }
  )

  useDidMountEffect(() => query({ batchId, disbursementId }), [batchId, disbursementId, query])

  return (
    <DisbursementDonationsTable
      isLoading={isLoading}
      totalResults={totalResults}
      data={dataOrNull}
      previousPage={previousPage}
      nextPage={nextPage}
      errorMessage={errorMessageOrNull}
    />
  )
}
